import { render, staticRenderFns } from "./AudioAndText.vue?vue&type=template&id=12759c42&scoped=true&"
import script from "./AudioAndText.vue?vue&type=script&lang=js&"
export * from "./AudioAndText.vue?vue&type=script&lang=js&"
import style0 from "./AudioAndText.vue?vue&type=style&index=0&id=12759c42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12759c42",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
